import { render, staticRenderFns } from "./WarrantyClaimsImport.vue?vue&type=template&id=ed5ca1c2&scoped=true&"
import script from "./WarrantyClaimsImport.vue?vue&type=script&lang=js&"
export * from "./WarrantyClaimsImport.vue?vue&type=script&lang=js&"
import style0 from "./WarrantyClaimsImport.vue?vue&type=style&index=0&id=ed5ca1c2&scoped=true&lang=css&"
import style1 from "./WarrantyClaimsImport.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed5ca1c2",
  null
  
)

export default component.exports